import { render, staticRenderFns } from "./bjManage.vue?vue&type=template&id=49e4eb67&scoped=true&"
import script from "./bjManage.vue?vue&type=script&lang=js&"
export * from "./bjManage.vue?vue&type=script&lang=js&"
import style0 from "./bjManage.vue?vue&type=style&index=0&id=49e4eb67&lang=less&scoped=true&"
import style1 from "./bjManage.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e4eb67",
  null
  
)

component.options.__file = "bjManage.vue"
export default component.exports